module.exports = {
  emptyMessage: 'Por favor, insira a validade do cartão.',
  expiredMessage: 'Ops! O cartão informado está vencido.',
  defaultMessage: 'A validade está incorreta.',
};
